import React from 'react';
import { NextPageContext } from 'next';
import { ErrorProps, ErrorProps as NextErrorProps } from 'next/error';

import CustomErrorPage from 'components/common/CustomErrorPage';

interface CustomErrorInitialProps extends NextErrorProps {
  isSSRReadyToRender?: boolean;
}
interface CustomErrorProps extends ErrorProps {
  statusCode: number;
}

const CustomError = (props: CustomErrorProps): JSX.Element => {
  const { statusCode } = props;

  return <CustomErrorPage statusCode={statusCode} />;
};

CustomError.getInitialProps = (context: NextPageContext): Promise<CustomErrorInitialProps> => {
  const { res, err } = context;
  // eslint-disable-next-line no-nested-ternary
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return Promise.resolve({ statusCode: statusCode || 404 });
};

export default CustomError;
